import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { TenantPage } from 'layouts';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import toast from 'shared/utils/toast';
import { transportActiveDocumentService } from '../api/transport-active-document.service';
import { AddButton } from 'components/ui';
import { TransportActiveDocumentColumns } from '../transport-active-document';

export function TransportActiveDocumentList() {
  const { t } = useTranslation();
  const prefix = 'pages.active-ddt.list';

  const navigate = useNavigate();
  const datagridRefresh = useRef(null);

  const downloadAttachment = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      transportActiveDocumentService.downloadAttachment(transportActiveDocumentId);
    }
  };

  const regenerateDocument = (transportActiveDocumentId) => {
    if (transportActiveDocumentId) {
      transportActiveDocumentService.regeneratePDF(transportActiveDocumentId).then(() => {
        toast.success('PDF rigenerato.');
      });
    }
  };

  const columns = TransportActiveDocumentColumns(true, downloadAttachment, regenerateDocument);

  return (
    <TenantPage
      title={t(`${prefix}.title`)}
      subtitle={t(`${prefix}.subtitle`)}
      menuRight={<AddButton requireTenantAdmin onClick={() => navigate('new')} prefix={prefix} />}>
      <EnhancedDataGrid
        columns={columns}
        service={transportActiveDocumentService}
        refresh={datagridRefresh}
      />
    </TenantPage>
  );
}

export default TransportActiveDocumentList;
